<template>
  <div>
    <v-select
      v-model="currentCourse"
      :items="courses"
      item-text="name"
      item-value="id"
      label="Курс"
    ></v-select>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="name"
      calculate-widths
      class="elevation-1"
    >
      <template v-for="slot in slots" v-slot:[slot.name]="{ item }">
        <v-chip :color="getColor(item[slot.key])" label :key="slot.key">
          {{ item[slot.key] }}%
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getListenerCourseStatusTableResponse } from '@/api/referenece'
import { getCoursesListResponse } from '@/api/hps/courses'
import isEmpty from 'lodash/isEmpty'

export default {
  name: 'ListenerCourse',
  data() {
    return {
      courses: [],
      lectures: {},
      currentCourse: '',
      tableData: [],
      items: [],
    }
  },
  computed: {
    slots() {
      return Object.keys(this.lectures).map((x) => {
        return { name: `item.${x}`, key: x }
      })
    },
    headers() {
      const header = [
        {
          text: '№ п/п',
          align: 'start',
          sortable: false,
          value: 'idx',
        },
        {
          text: 'ФИО Зарегистривовавшегося',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Дата регистрации',
          align: 'start',
          sortable: true,
          value: 'subscribe_date',
          width: '100',
        },
      ]

      for (const [key, value] of Object.entries(this.lectures)) {
        header.push({
          text: value,
          align: 'start',
          sortable: true,
          value: key,
        })
      }
      return header
    },
  },
  watch: {
    currentCourse(x) {
      if (isEmpty(x)) {
        return
      }
      this.getTableData()
    },
  },
  async mounted() {
    const courseListResponse = await getCoursesListResponse(this.axios, {})
    this.courses = courseListResponse.data
  },
  methods: {
    getColor(value) {
      if (value < 1) {
        return 'error'
      }
      if (value < 50) {
        return 'yellow lighten-2'
      }
      if (value >= 100) {
        return 'light-green'
      }
      return 'light-green lighten-2'
    },
    getTableData() {
      getListenerCourseStatusTableResponse(this.axios, this.currentCourse)
        .then((resp) => {
          this.tableData = resp.data
          this.prepareTableData(resp.data)
        })
        .catch((err) => this.showSnackbar(err, 'error'))
    },
    prepareTableData(data) {
      const lectures = {}
      const items = []
      data.lecture_ids.forEach((v, i) => {
        lectures[v] = data.lecture_names[i]
      })
      data.consumers.forEach((x, i) => {
        const item = {
          idx: i + 1,
          name: `${x.name} ${x.phone_number}`,
          subscribe_date: this.$moment(x.subscribe_date).format('LLL'),
        }
        for (const key of Object.keys(lectures)) {
          item[key] = Math.floor(Math.min(x.lectures[key].percent_of_tics, 100))
        }
        items.push(item)
      })
      this.lectures = lectures
      this.items = items
      return items
    },
  },
}
</script>
